import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import PrivateRoute from "./components/PrivateRoute";
import AudioTranscribe from "./pages/AudioTranscribe";
import VoiceTranscribe from "./pages/VoiceTranscribe";
import Translate from "./pages/Translation";
import PdfToText from "./pages/PdfToText";
import VoiceRecording from "./pages/VoiceRecording";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Profile from "./pages/Profile";
import Footer from "./components/Footer";
import FAQs from "./pages/FAQs";
import ContactPage from "./components/Contact";

const App = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/audio-transcribe" element={<AudioTranscribe />} />
        <Route path="/voice-transcribe" element={<VoiceTranscribe />} />
        <Route path="/translate" element={<Translate />} />
        <Route path="/pdf-to-text" element={<PdfToText />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route element={<PrivateRoute />}></Route>
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
